import { createContext } from 'react';

import type { StreamChat } from 'stream-chat';

type TLiveValue = {
  client: StreamChat | null;
  totalUnread: number;
  isChatReady: boolean;
  isChatConfigured: boolean;
};

const EMPTY_LIVE: TLiveValue = {
  client: null,
  totalUnread: 0,
  isChatReady: false,
  isChatConfigured: false,
};

const LiveContext = createContext<TLiveValue>(EMPTY_LIVE);

export type {
  TLiveValue,
};
export {
  EMPTY_LIVE,
  LiveContext,
};
